import { useDispatch, useSelector } from 'react-redux';
import {
    getAcademyBeginnersGuideOnboardingLessonSelector,
    getIsAcademyEnabledSelector,
    getIsShowAcademyBeginnersGuideInviteSelector,
} from './academySelectors';
import { getIsLocationPlatformMobileSelector } from '../Location/locationSelectors';
import { useEffect } from 'react';
import { makeSelectAppLoggedIn } from '../../app/appSelectors';
import { academySlice } from './academyReducer';
import useAcademyBeginnersGuideInvite from './hooks/useAcademyBeginnersGuideInvite';
import BeginnersGuideInviteDesktop from './BeginnersGuideInvite/BeginnersGuideInviteDesktop';
import BeginnersGuideInviteMobile from './BeginnersGuideInvite/BeginnersGuideInviteMobile';

function AcademyProvider() {
    const isAcademyEnabled = useSelector(getIsAcademyEnabledSelector);
    const isShowBeginnersGuideInvite = useSelector(getIsShowAcademyBeginnersGuideInviteSelector);
    const isMobilePlatform = useSelector(getIsLocationPlatformMobileSelector);
    const isLoggedIn = useSelector(makeSelectAppLoggedIn());
    const dispatch = useDispatch();
    const beginnersGuideOnboardingLesson = useSelector(getAcademyBeginnersGuideOnboardingLessonSelector);
    const isAllowShowBeginnersGuideInvite = isAcademyEnabled && !!beginnersGuideOnboardingLesson && isShowBeginnersGuideInvite;

    const inviteProps = useAcademyBeginnersGuideInvite({ isAllowShow: isAllowShowBeginnersGuideInvite });

    useEffect(() => {
        if (isLoggedIn) {
            dispatch(academySlice.actions.initAcademyAction());
        }
    }, [dispatch, isLoggedIn]);

    return <>
        {
            isAllowShowBeginnersGuideInvite && <>
                {isMobilePlatform && <BeginnersGuideInviteMobile {...inviteProps}/>}
                {!isMobilePlatform && <BeginnersGuideInviteDesktop {...inviteProps}/>}
            </>
        }
    </>;
}

export default AcademyProvider;
